import checkout from "./form";

const {
  formField: { number, description, location, timezone, project, status },
} = checkout;

export default {
  [number.name]: "",
  [description.name]: "",
  [location.name]: "",
  [timezone.name]: "",
  [project.name]: "",
  [status.name]: true,
};
